import { createElementVNode as _createElementVNode, withKeys as _withKeys, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "operations" }
const _hoisted_2 = { class: "row justify-content-center" }
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "operations__head" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "operations__head__title" }, [
    /*#__PURE__*/_createElementVNode("span", null, "Operaciones")
  ])
], -1)
const _hoisted_5 = { class: "operations__body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "policies__input-dates" }
const _hoisted_9 = { class: "policies__input-dates__input" }
const _hoisted_10 = { class: "input-group mb-3" }
const _hoisted_11 = { class: "policies__input-dates__start-date" }
const _hoisted_12 = { class: "input-group mb-3" }
const _hoisted_13 = { class: "policies__input-dates__end-date" }
const _hoisted_14 = { class: "input-group mb-3" }
const _hoisted_15 = { class: "policies__input-dates__btn-policies" }
const _hoisted_16 = {
  key: 0,
  class: "operations__body__load"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-circle-notch fa-spin d-block mb-1" }, null, -1)
const _hoisted_18 = {
  key: 1,
  class: "table table-hover table-striped operations__body__table"
}
const _hoisted_19 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Póliza"),
    /*#__PURE__*/_createElementVNode("th", null, "Tipo"),
    /*#__PURE__*/_createElementVNode("th", null, "Fecha de solicitud"),
    /*#__PURE__*/_createElementVNode("th", null, "Importe"),
    /*#__PURE__*/_createElementVNode("th", null, "Prima"),
    /*#__PURE__*/_createElementVNode("th", null, "Años"),
    /*#__PURE__*/_createElementVNode("th", null, "Estado"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 0 }
const _hoisted_24 = {
  key: 0,
  class: "fas fa-arrow-up text-success"
}
const _hoisted_25 = {
  key: 1,
  class: "fas fa-arrow-down text-danger"
}
const _hoisted_26 = {
  key: 0,
  class: "badge badge-purple"
}
const _hoisted_27 = {
  key: 1,
  class: "badge badge-success"
}
const _hoisted_28 = {
  key: 2,
  class: "badge badge-danger"
}
const _hoisted_29 = { class: "operations__body__table__actions" }
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = {
  key: 1,
  class: "fas fa-circle-notch fa-spin"
}
const _hoisted_37 = {
  key: 0,
  class: "pagination"
}
const _hoisted_38 = { class: "modal-error__head" }
const _hoisted_39 = ["src"]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("h3", null, "Ups!", -1)
const _hoisted_41 = { class: "modal-error__head" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_datepicker = _resolveComponent("datepicker")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_pagination = _resolveComponent("pagination")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "form-control",
                        placeholder: "Ingrese búsqueda",
                        "aria-label": "Username",
                        "aria-describedby": "basic-addon1",
                        onKeyup: _cache[0] || (_cache[0] = _withKeys(($event: any) => (_ctx.loadOperations()), ["native","enter"])),
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.query.q) = $event))
                      }, null, 544), [
                        [_vModelText, _ctx.query.q]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_datepicker, {
                        "model-value": _ctx.query.startDate,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.query.startDate) = $event)),
                        clearable: false
                      }, null, 8, ["model-value"]),
                      _createElementVNode("button", {
                        class: "clear-date",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.clearDate(true)))
                      }, " ✕ ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_datepicker, {
                        "model-value": _ctx.query.endDate,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.query.endDate) = $event)),
                        clearable: false
                      }, null, 8, ["model-value"]),
                      _createElementVNode("button", {
                        class: "clear-date",
                        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clearDate(false)))
                      }, " ✕ ")
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadOperations()))
                    }, " Buscar ")
                  ])
                ]),
                (_ctx.flags.searching)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _hoisted_17,
                      _createTextVNode(" Cargando operaciones... ")
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.flags.searching)
                  ? (_openBlock(), _createElementBlock("table", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operations, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: item.additionalContributionId
                          }, [
                            _createElementVNode("td", null, [
                              _createVNode(_component_router_link, {
                                to: {
                            name: 'admineditpolicy',
                            query: {
                              policyNumber: item.policy.referencePolicyId,
                            },
                          }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(item.policy.referencePolicyId), 1)
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _createElementVNode("td", null, [
                              (item.additionalContributionType === 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_20, "Pago adicional"))
                                : _createCommentVNode("", true),
                              (item.additionalContributionType === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Endoso"))
                                : _createCommentVNode("", true),
                              (item.additionalContributionType === 3)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_22, "Congelamiento"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.createdOn)), 1),
                            _createElementVNode("td", null, [
                              (
                            item.additionalContributionType === 1 ||
                            item.additionalContributionType === 2
                          )
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (item.additionalContributionType === 1)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, "S/" + _toDisplayString(item.amount), 1))
                                      : _createCommentVNode("", true),
                                    (item.additionalContributionType === 2)
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: _normalizeClass({
                              'text-danger':
                                item.policy.paymentAmount > item.amount,
                              'text-success':
                                item.policy.paymentAmount < item.amount,
                            })
                                        }, [
                                          (item.policy.paymentAmount < item.amount)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_24))
                                            : _createCommentVNode("", true),
                                          (item.policy.paymentAmount > item.amount)
                                            ? (_openBlock(), _createElementBlock("i", _hoisted_25))
                                            : _createCommentVNode("", true),
                                          _createTextVNode(" S/" + _toDisplayString(item.amount), 1)
                                        ], 2))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (item.additionalContributionType === 3)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    _createTextVNode(" -- ")
                                  ], 64))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", null, "S/" + _toDisplayString(item.policy.paymentAmount), 1),
                            _createElementVNode("td", null, _toDisplayString(item.policy.periodicity), 1),
                            _createElementVNode("td", null, [
                              (item.additionalContributionStatus === 1)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_26, "Pendiente"))
                                : _createCommentVNode("", true),
                              (item.additionalContributionStatus === 2)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_27, "Aprobado"))
                                : _createCommentVNode("", true),
                              (item.additionalContributionStatus === 3)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_28, "Rechazado"))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("td", _hoisted_29, [
                              (!item.loading)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    (item.additionalContributionStatus === 1)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 0,
                                          role: "button",
                                          class: "text-main",
                                          onClick: ($event: any) => (_ctx.approve(item)),
                                          title: "Aprobar"
                                        }, _hoisted_32, 8, _hoisted_30))
                                      : _createCommentVNode("", true),
                                    (item.additionalContributionStatus === 1)
                                      ? (_openBlock(), _createElementBlock("a", {
                                          key: 1,
                                          role: "button",
                                          class: "text-danger ml-2",
                                          onClick: ($event: any) => (_ctx.cancel(item)),
                                          title: "Rechazar"
                                        }, _hoisted_35, 8, _hoisted_33))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                : _createCommentVNode("", true),
                              (item.loading)
                                ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                                : _createCommentVNode("", true)
                            ])
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.operations && _ctx.operations.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createVNode(_component_pagination, {
                      modelValue: _ctx.page,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.page) = $event)),
                      records: _ctx.rowCount,
                      "per-page": 20,
                      onPaginate: _ctx.changePage
                    }, null, 8, ["modelValue", "records", "onPaginate"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_b_modal, {
      id: "modal-error",
      "ok-only": "",
      "ok-title": "Entiendo",
      centered: "",
      size: "sm",
      "modal-class": "modal-error",
      ref: "modal-error"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_38, [
          _createElementVNode("img", {
            src: require('@/assets/images/app/alert.svg'),
            alt: ""
          }, null, 8, _hoisted_39),
          _hoisted_40
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("p", null, _toDisplayString(_ctx.errors.message), 1)
        ])
      ]),
      _: 1
    }, 512)
  ]))
}